import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AddTokenPackage } from "../../../../store/tokenpackage/actions";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";

const AddTokenPack = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.Subscription);
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    tokens: "",
    minutes: "",
    status: "active",
    benefits: [""],
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "number") {
      if (value === "") {
        setFormData({
          ...formData,
          [name]: "",
        });
        return;
      }
      const numericValue = parseFloat(value);
      if (isNaN(numericValue) || numericValue < 0) {
        return;
      }
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleBenefitsChange = (index, value) => {
    const newBenefits = [...formData.benefits];
    newBenefits[index] = value;
    setFormData({ ...formData, benefits: newBenefits });
  };

  const addBenefit = () => {
    setFormData({
      ...formData,
      benefits: [...formData.benefits, ""],
    });
  };

  const removeBenefit = (index) => {
    const newBenefits = formData.benefits.filter((_, i) => i !== index);
    setFormData({ ...formData, benefits: newBenefits });
  };

  const handleSubmit_ = (info) => {
    // Filter out empty benefits
    const cleanedData = {
      ...info,
      benefits: info.benefits.filter((benefit) => benefit.trim() !== ""),
    };

    console.log(cleanedData, "data");
    try {
      const callback = (err, res) => {
        if (err) {
          console.error(err, "error message");
          toast.error(err);
        } else {
          console.log(res);
          toast.success("Token Pack Created Successfully");
          navigate(`/token`);
        }
      };
      dispatch(
        AddTokenPackage({
          data: cleanedData,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      price: "",
      tokens: "",
      minutes: "",
      status: "active",
      benefits: [""],
    });
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="addForm position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <Form
                  className="mx-auto"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit_(formData);
                  }}
                >
                  <div className="py-3">
                    <div className="topHead pb-2">
                      <h5 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
                        Add New Token Pack:
                      </h5>
                    </div>
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row className="justify-content-center">
                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">
                            Pack Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter Pack Name (e.g., Mini Pack)"
                            required
                          />
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">
                            Price ($)
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            className="form-control"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            placeholder="Enter Price (e.g., 4.99)"
                            required
                          />
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">Tokens</label>
                          <input
                            type="number"
                            className="form-control"
                            name="tokens"
                            value={formData.tokens}
                            onChange={handleChange}
                            placeholder="Enter Token Count (e.g., 200)"
                            required
                          />
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">
                            Minutes
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="minutes"
                            value={formData.minutes}
                            onChange={handleChange}
                            placeholder="Enter Minutes (e.g., 20)"
                            required
                          />
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">Status</label>
                          <select
                            className="form-control"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </Col>

                        {/* Benefits (Dynamic Array) */}
                        <Col md="12" className="my-3">
                          <label className="form-label fw-sbold">
                            Benefits
                          </label>
                          {formData.benefits.map((benefit, index) => (
                            <div
                              key={index}
                              className="d-flex align-items-center mb-2"
                            >
                              <input
                                type="text"
                                className="form-control me-2"
                                value={benefit}
                                onChange={(e) =>
                                  handleBenefitsChange(index, e.target.value)
                                }
                                placeholder="Enter benefit (e.g., Perfect for trying additional conversations)"
                              />
                              <Button
                                variant="danger"
                                className="btn-sm"
                                onClick={() => removeBenefit(index)}
                                disabled={formData.benefits.length === 1}
                              >
                                Remove
                              </Button>
                            </div>
                          ))}
                          <Button className="mt-2 btn-sm" onClick={addBenefit}>
                            Add More
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="py-3">
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row>
                        <Col md="5" className="my-2">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn w-100 fw-sbold"
                            type="submit"
                          >
                            Create Token Pack
                          </Button>
                        </Col>
                        <Col md="5" className="my-2">
                          <Button
                            variant="secondary"
                            className="d-flex align-items-center justify-content-center w-100 fw-sbold"
                            type="button"
                            onClick={handleReset}
                          >
                            Reset
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddTokenPack;